export enum OAuth2SalesforcePrompt {
    Login = 'login',
    Consent = 'consent',
}
